import { ConfirmDialog } from "../../ui";

type DeleteCourtDialogProps = {
  courtName: string;
  isOpen: boolean;
  onDelete: () => Promise<void>;
  onClose: (update?: boolean) => void;
};

const DeleteCourtDialog = (props: DeleteCourtDialogProps) => (
  <ConfirmDialog
    open={props.isOpen}
    // Error is handled by the parent component; a failed delete keeps the dialog open
    onConfirm={props.onDelete}
    onClose={(confirmed) => props.onClose(confirmed ? true : undefined)}
    title="Delete Court"
    heading="Are you sure?"
    confirmLabel="Delete"
    message={
      <>
        This action cannot be undone. If you delete <strong>{props.courtName}</strong>, it will be permanently removed.
      </>
    }
  />
);

export default DeleteCourtDialog;
